import {ROUTER_PATH_INDEX, ROUTER_PATH_ROOT} from "./constantsApp";
import {ContainerConfigInterface} from "./interface";

export const PAI_POINT_AUTH: string = 'auth'

export const ROUTER_PATH_ADMIN: string[] = [
    '/admin/home',
    '/admin/workFlow',
    '/admin/infoChart',
    '/admin/systemConfig',
    '/admin/personalConfig',
    '/admin/permissionsConfig',
]

export const MAIN_ROUTER_LIST: string[] = [
    ROUTER_PATH_ROOT,
    ROUTER_PATH_INDEX
]

export const CONTAINER_CONFIG_DEFAULT: ContainerConfigInterface = {
    paddingTop: '0',
    paddingLeft: '0',
    paddingRight: '0',
    paddingBottom: '0',
    marginTop: '0',
    marginLeft: '0',
    marginRight: '0',
    marginBottom: '0',
    justifyContent: 'start',
    backgroundColor: 'transparent',
}

export const BACKEND_URL: string = 'http://localhost:8082';

export const REQUEST_API_CODE_ENUM = {
    SUCCESS: '0',
}

export const DEFAULT_BUSINESS_ID: string = 'paipoint'